export default "__VITE_ASSET__5a1039cd__";